export default "__VITE_ASSET__a$8D3qU7__"